import { render, staticRenderFns } from "./requests-footer.vue?vue&type=template&id=5c7a63ce&scoped=true&"
import script from "./requests-footer.vue?vue&type=script&lang=js&"
export * from "./requests-footer.vue?vue&type=script&lang=js&"
import style0 from "./requests-footer.vue?vue&type=style&index=0&id=5c7a63ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a63ce",
  null
  
)

export default component.exports